import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Ruta de la pantalla de acceso. La comparten los dos guardias y el logout. */
export const RUTA_ACCESO = '/acceso';

/** Primera pantalla tras entrar. */
export const RUTA_INICIO = '/pulso';

/**
 * Protege el tablero.
 *
 * Guarda a dónde iba el usuario en `regresarA`: quien abre un enlace directo a
 * `/explorar` y tiene que pasar por el acceso espera aterrizar en Explorar, no
 * en Pulso.
 */
export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  if (authService.autenticado()) {
    return true;
  }

  // Pulso es a donde se va por omisión: anotarlo en la URL sólo ensucia la
  // barra de direcciones sin decir nada nuevo.
  const destino: string = state.url;
  const vale: boolean = !!destino && destino !== '/' && !destino.startsWith(RUTA_INICIO);

  return router.createUrlTree([RUTA_ACCESO], {
    queryParams: vale ? { regresarA: destino } : {},
  });
};

/**
 * El reverso: con sesión abierta, la pantalla de acceso no tiene nada que
 * ofrecer. Sin esto, el botón «atrás» después de entrar devuelve a un
 * formulario de acceso ya resuelto.
 */
export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return authService.autenticado() ? router.createUrlTree([RUTA_INICIO]) : true;
};
